module.exports = __webpack_public_path__ + "media/stylesheets/images/register_coupon_register-01c6df8831091d0feb0627f5e6b630a7.svg";